<ng-container>
  <div class="sso-page">
    <div class="unauthorized-error">
      <div class="container">
        <div class="unauth-img"></div>
        <h1>{{ 'userData.insufficientRights' | cxTranslate }}</h1>
        <p>
          {{ 'userData.insufficientRights2' | cxTranslate }}
          <br />
          {{ 'userData.error' | cxTranslate }}
        </p>
        <a (click)="redirectToContactUs()">
          {{ 'userData.know' | cxTranslate }}
        </a>
      </div>
    </div>
  </div>
</ng-container>
